/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ConclusionCard {
  Generic = 'Generic',
  Messaging = 'Messaging',
  VideoAppointment = 'VideoAppointment'
}
